import { render } from "./MonacoEditor.vue?vue&type=template&id=d1bb77d8&ts=true"
import script from "./MonacoEditor.vue?vue&type=script&lang=ts"
export * from "./MonacoEditor.vue?vue&type=script&lang=ts"

import "./MonacoEditor.vue?vue&type=style&index=0&id=d1bb77d8&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__